module.exports = __webpack_public_path__ + "img/se.fe725901.svg";